// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"7da54151","251":"b2223eae","453":"258b012d","455":"c99e55f7","770":"e6931506","977":"37d9e8f3"}[chunkId] + ".chunk.js";
};